import { render, staticRenderFns } from "./LabelChip.vue?vue&type=template&id=5e00d5b6&scoped=true&"
import script from "./LabelChip.vue?vue&type=script&lang=js&"
export * from "./LabelChip.vue?vue&type=script&lang=js&"
import style0 from "./LabelChip.vue?vue&type=style&index=0&id=5e00d5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00d5b6",
  null
  
)

export default component.exports